import React, { useContext, useEffect, useState } from "react";
import { StudentContext } from "./StudentLayout";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { Wallet } from "lucide-react";

const StudentPayments = () => {
  const { student } = useContext(StudentContext);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      if (!student?.uid) return;
      try {
        const q = query(collection(db, "payments"), where("uid", "==", student.uid));
        const snap = await getDocs(q);
        setPayments(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (e) { console.error(e); }
      setLoading(false);
    };
    fetch();
  }, [student]);

  return (
    <div data-testid="student-payments">
      <div className="mb-8">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600 mb-2">Payments</div>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">Payment History</h1>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
        {loading ? (
          <div className="p-10 text-center text-slate-500">Loading...</div>
        ) : payments.length === 0 ? (
          <div className="p-10 text-center text-slate-500">
            <Wallet className="w-12 h-12 text-slate-300 mx-auto mb-3" />
            No payments recorded.
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-600">
              <tr>
                <th className="text-left px-6 py-3 font-semibold">Payment ID</th>
                <th className="text-left px-6 py-3 font-semibold">Plan</th>
                <th className="text-left px-6 py-3 font-semibold">Amount</th>
                <th className="text-left px-6 py-3 font-semibold">Status</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((p) => (
                <tr key={p.id} className="border-t border-slate-100">
                  <td className="px-6 py-3 font-mono text-xs text-slate-700">{p.razorpayPaymentId || p.id}</td>
                  <td className="px-6 py-3 text-slate-900">{p.selectedPlan}</td>
                  <td className="px-6 py-3 font-semibold text-slate-900">₹{p.amount}</td>
                  <td className="px-6 py-3">
                    <span className="px-2.5 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-semibold capitalize">
                      {p.paymentStatus}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default StudentPayments;
